module.exports = __webpack_public_path__ + "static/LogoDark-b3c030a82924fdae13baaa98db08c4be.png";